import { createFileRoute } from '@tanstack/react-router';

import { Basic } from '@/view/pages/Decoupages/Basic';

export const Route = createFileRoute('/_protected/$programId/decupagens/basica/')({
  component: Basic,
  context: (context): { title: string } => ({
    ...context,
    title: 'Decupagem Básica',
  }),
});
